import styled from 'styled-components';
import { COLORS } from '../../../Constants';

export default styled.div`
  border-top: 1px solid ${COLORS.black1};
  margin: 10px 0;
`;
